export function handleBetDetailsImageError(iconRef) {
    const imageElement = iconRef.current;
    if (imageElement === null || imageElement === void 0 ? void 0 : imageElement.parentElement) {
        imageElement.parentElement.style.display = "none";
    }
}
//# sourceMappingURL=handleBetDetailsImageError.js.map